/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { Loading } from "notiflix/build/notiflix-loading-aio";
import moment from "moment";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { dateFormat, tables } from "utils/constants";
import Alert from "components/CustomAlert";
import { resetForwardSection } from "store/entities/notifications";
import { useGetAllEmailHistoryQuery } from "services/send_email";

function EmailHistory() {
  const dispatch = useDispatch();
  const navigate = useHistory();
  const { data: emailsList = [], isSuccess } = useGetAllEmailHistoryQuery();

  useEffect(() => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });

    isSuccess && Loading.remove(500);
  }, [isSuccess]);

  useEffect(() => {
    return () => {
      dispatch(resetForwardSection());
    };
  }, []);

  return (
    <Card>
      <CardHeader
        title={<MDTypography color="info">Email History</MDTypography>}
        action={
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => navigate.push(`/user/send-email`)}
          >
            Send Email
          </MDButton>
        }
      />
      <CardContent>
        <br />

        {emailsList && emailsList.length > 0 ? (
          <DataTable
            id={tables.EMAIL_HISTORY}
            columns={[
              {
                Header: "Id",
                accessor: "id",
              },
              {
                Header: "Date",
                accessor: "datetime",
                Cell: ({ row: { original } }) => moment(original.datetime).format(dateFormat),
              },
              {
                Header: "Subject",
                accessor: "subject",
              },
              {
                Header: "To",
                accessor: "to",
              },

              {
                Header: "CC",
                accessor: "cc",
              },
              {
                Header: "BCC",
                accessor: "bcc",
              },
            ]}
            data={emailsList || []}
            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={false}
            hideColumnSelection={false}
            noEndBorder
            canSearch
            stateReducer={(newState, action) => {
              if (action.type === "toggleRowSelected") {
                newState.selectedRowIds = {
                  [action.id]: action.value,
                };
              }
              return newState;
            }}
          />
        ) : (
          <Alert severity="warning">No Emails found!</Alert>
        )}
      </CardContent>
    </Card>
  );
}

export default EmailHistory;
